import { Link } from "react-router-dom";
import { CheckCircle, ArrowRight } from "@phosphor-icons/react";
import { motion } from "framer-motion";

export default function PaymentSuccess() {
  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-28 sm:py-36">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-xl mx-auto text-center" data-testid="payment-success-page">
        <CheckCircle size={64} weight="fill" className="mx-auto text-black" />
        <h1 className="mt-6 font-display text-4xl sm:text-5xl font-black tracking-tighter">Thank you!</h1>
        <p className="mt-4 text-lg text-zinc-600">
          Your subscription is being activated. You'll receive a confirmation email as soon as your first
          payment is verified, and our team will reach out to get started.
        </p>
        <p className="mt-3 text-sm text-zinc-500">
          Your subscription renews automatically each month. You can manage or cancel anytime from the billing
          portal on the pricing page.
        </p>
        <Link to="/pricing" className="mt-8 inline-flex items-center gap-2 rounded-full bg-black text-white font-medium px-7 py-4 hover:bg-zinc-800 transition-colors">
          Back to pricing <ArrowRight size={18} />
        </Link>
      </motion.div>
    </div>
  );
}
